import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { login } from '../api/auth'

export default function Login() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [showPassword, setShowPassword] = useState(false)
  const [error, setError] = useState(null)
  const [f, setF] = useState({ email: '', username: '', password: '' })
  const up = (k, v) => setF(prev => ({ ...prev, [k]: v }))

  async function handleSubmit(e){
    e.preventDefault()
    setError(null)
    try {
      await login(f)
      navigate('/')
    } catch(err) {
      console.error(err)
      setError(t('auth.login_failed', 'Identifiants invalides'))
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="bg-white shadow-md rounded-2xl w-full max-w-md p-8">
        <h1 className="text-3xl font-extrabold text-blue-900 mb-2 text-center">
          {t('auth.welcome_back','Bienvenue à nouveau')}
        </h1>
        <p className="text-gray-600 text-center mb-8">
          {t('auth.enter_info','Veuillez entrer vos informations.')}
        </p>

        {error && <div className="mb-4 text-red-700 bg-red-50 border border-red-200 rounded px-3 py-2">{error}</div>}

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block font-semibold text-gray-700 mb-1">E-mail (ou laissez vide et utilisez le nom d’utilisateur)</label>
            <input
              type="email"
              placeholder="E-mail"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
              value={f.email}
              onChange={(e)=>up('email', e.target.value)}
            />
          </div>

          <div>
            <label className="block font-semibold text-gray-700 mb-1">Nom d’utilisateur (optionnel)</label>
            <input
              type="text"
              placeholder="Nom d’utilisateur"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
              value={f.username}
              onChange={(e)=>up('username', e.target.value)}
            />
          </div>

          <div className="relative">
            <label className="block font-semibold text-gray-700 mb-1">Mot de passe</label>
            <input
              type={showPassword ? 'text' : 'password'}
              required
              placeholder="Mot de passe"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
              value={f.password}
              onChange={(e)=>up('password', e.target.value)}
            />
            <button type="button" className="absolute right-3 top-9 text-gray-500" onClick={() => setShowPassword(s=>!s)}>
              {showPassword ? '🙈' : '👁️'}
            </button>
          </div>

          <button type="submit" className="w-full py-3 bg-blue-600 text-white font-bold rounded-lg hover:bg-blue-700 transition">
            Connexion
          </button>
        </form>

        <p className="text-center text-gray-700 mt-6">
          {t('authui.noAccount','Vous n’avez pas de compte ?')}{' '}
          <Link to="/signup" className="text-blue-600 font-semibold hover:underline">
            {t('auth.signup','Inscription')}
          </Link>
        </p>
      </div>
    </div>
  )
}
